import { type PropsWithChildren } from 'react';

import { NOODLE_THEME_STYLE } from '@/providers/CreatorUI';

const NoodleTheme: React.FC<PropsWithChildren> = ({ children }) => <div style={NOODLE_THEME_STYLE}>{children}</div>;

export default NoodleTheme;
